// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2fqRg","additionalInfo":"AgreementModal_additionalInfo__1dGoR"};